import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const ModalComponent = ({ isOpen, onClose, children }) => {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <>
            <IoClose className="text-white modal-close-icon d-none d-lg-block" size={40} onClick={onClose} />
            <div className={`custom-modal-layer ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`custom-modal ${isOpen ? 'show' : ''}`}>
                <IoClose className="modal-close-icon-mobile d-block d-lg-none" size={30} onClick={onClose} />
                <div className="content radius-20">
                    <div className="content-item">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalComponent;
